import SimpleDate from './SimpleDate';

export default SimpleDate;
